import React from 'react';
import { AlertTriangle } from 'lucide-react';

/**
 * AgentErrorBlock — displays a mid-session error with retry/skip/undo options.
 *
 * Props:
 *   message: { error, tool, completed_steps, options }
 *   onRetry()
 *   onSkip()
 *   onUndo()
 */
const AgentErrorBlock = ({ message, onRetry, onSkip, onUndo }) => {
  const options = message.options || [];

  return (
    <div className="my-2 border border-orange-200 rounded-lg bg-orange-50 overflow-hidden">
      <div className="flex items-start gap-2 px-4 py-3">
        <AlertTriangle size={15} className="text-orange-500 flex-shrink-0 mt-0.5" />
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-orange-800">
            Step failed: {message.tool?.replace(/_/g, ' ')}
          </p>
          <p className="text-sm text-orange-700 mt-0.5">{message.error}</p>
          {message.completed_steps?.length > 0 && (
            <p className="text-xs text-orange-600 mt-1">
              Completed steps: {message.completed_steps.map((s) => s + 1).join(', ')} ✓
            </p>
          )}
        </div>
      </div>

      {options.length > 0 && (
        <div className="flex gap-2 px-4 py-2 border-t border-orange-200">
          {options.includes('retry') && (
            <button
              onClick={onRetry}
              className="text-xs font-medium text-orange-700 hover:text-orange-900 border border-orange-300 rounded px-2 py-1 hover:bg-orange-100 transition-colors"
            >
              Retry step
            </button>
          )}
          {options.includes('skip') && (
            <button
              onClick={onSkip}
              className="text-xs font-medium text-orange-700 hover:text-orange-900 border border-orange-300 rounded px-2 py-1 hover:bg-orange-100 transition-colors"
            >
              Skip and continue
            </button>
          )}
          {options.includes('undo') && (
            <button
              onClick={onUndo}
              className="text-xs font-medium text-red-600 hover:text-red-800 border border-red-300 rounded px-2 py-1 hover:bg-red-50 transition-colors"
            >
              Undo completed steps
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default AgentErrorBlock;
